import React from 'react'
import NavItem from '../Atoms/Items/NavItem'
import {useDispatch} from 'react-redux'
import {signOut} from '../../services/user'
import routes from '../../config/routes'

const MainMenu = () => {
  const dispatch = useDispatch()

  const handleSignOut = () => dispatch(signOut())

  return (
    <div className="flex flex-grow s-overflow-y-auto">
      <nav className="s-column flex-grow">
        <ul className="list-container ed-grid row-gap s-gap-1 full">
          <NavItem text="Inicio" icon="home" url={routes.dashboard} />
          <NavItem text="Empleados" icon="users" url={routes.employees} />
          <NavItem text="Nómina" icon="document" url={routes.payroll} />
          <NavItem text="Empresa" icon="building" url={routes.company} />
          <NavItem text="Perfil" icon="user" url={routes.profile} />
        </ul>

        <hr className="to-lg s-pt-12px s-mb-12px" />

        <ul className="lg-to-bottom list-container ed-grid full row-gap s-gap-1">
          <NavItem text="Ayuda" icon="help" />
          <NavItem
            className="logout"
            text="Cerrar sesión"
            icon="exit"
            onClick={handleSignOut}
          />
        </ul>
      </nav>
    </div>
  )
}

export default MainMenu
